export default {
  name: 'internetConnectivityMixin',
  methods: {
    handleConnectivityOnlineEvent() {
      window.addEventListener('online', (event) => {
        this.$emit('internet_connectivity_status', true);
      });
    },

    handleConnectivityOfflineEvent() {
      window.addEventListener('offline', (event) => {
        this.$emit('internet_connectivity_status', false);
      });
    },
  },

  created() {
    this.handleConnectivityOnlineEvent();
    this.handleConnectivityOfflineEvent();
  },
};
